import { CheckIcon } from '../icons/CheckIcon';

export function Celebration() {
  return (
    <div
      className="relative h-[540px] w-[960px] overflow-hidden rounded-[10px] shadow-[0_1px_1px_-0.1px_rgba(0,0,0,0.05),0_1.98px_3.06px_-0.36px_rgba(0,0,0,0.05),0_5.881px_14.045px_-1.944px_rgba(0,0,0,0.09),0_23.287px_85.958px_-13.997px_rgba(0,0,0,0.19)]"
      style={{
        background: 'linear-gradient(135deg, #FEF6E9 0%, #FCE0CC 55%, #F7C7C0 100%)',
      }}
    >
      <Confetti />

      <div className="relative flex h-full flex-col items-center justify-center gap-l">
        <span className="flex size-[120px] items-center justify-center rounded-full bg-white text-content shadow-[0_24px_60px_rgba(0,0,0,0.08)]">
          <CheckIcon className="size-12" />
        </span>

        <div className="flex flex-col items-center gap-1">
          <h2 className="text-[40px] font-medium leading-[48px] text-content">
            You&apos;re all set!
          </h2>
          <p className="text-[14px] leading-[20px] text-content-muted">
            Postmaster Tools is connected.
          </p>
        </div>
      </div>
    </div>
  );
}

function Confetti() {
  const pieces: Piece[] = [
    { kind: 'circle', x: 8, y: 14, size: 12, color: '#FF7B5A' },
    { kind: 'circle', x: 90, y: 10, size: 9, color: '#5B6BFF' },
    { kind: 'circle', x: 22, y: 78, size: 7, color: '#251B18' },
    { kind: 'circle', x: 78, y: 80, size: 14, color: '#FFD24A' },
    { kind: 'circle', x: 50, y: 8, size: 6, color: '#251B18' },
    { kind: 'rect', x: 12, y: 36, size: 14, color: '#5B6BFF', rotate: 18 },
    { kind: 'rect', x: 84, y: 42, size: 12, color: '#FF7B5A', rotate: -22 },
    { kind: 'rect', x: 34, y: 88, size: 10, color: '#5B6BFF', rotate: 35 },
    { kind: 'triangle', x: 4, y: 60, size: 16, color: '#FFD24A', rotate: 10 },
    { kind: 'triangle', x: 92, y: 62, size: 14, color: '#E07856', rotate: -30 },
    { kind: 'triangle', x: 68, y: 14, size: 12, color: '#251B18', rotate: 65 },
    { kind: 'squiggle', x: 18, y: 22, size: 24, color: '#251B18', rotate: -10 },
    { kind: 'squiggle', x: 80, y: 28, size: 26, color: '#FF7B5A', rotate: 22 },
    { kind: 'squiggle', x: 42, y: 92, size: 22, color: '#5B6BFF', rotate: -8 },
  ];
  return (
    <div className="pointer-events-none absolute inset-0">
      {pieces.map((p, i) => (
        <ConfettiPiece key={i} piece={p} />
      ))}
    </div>
  );
}

type Piece = {
  kind: 'circle' | 'rect' | 'triangle' | 'squiggle';
  x: number;
  y: number;
  size: number;
  color: string;
  rotate?: number;
};

function ConfettiPiece({ piece }: { piece: Piece }) {
  const { kind, x, y, size, color, rotate = 0 } = piece;
  const style = {
    left: `${x}%`,
    top: `${y}%`,
    transform: `translate(-50%, -50%) rotate(${rotate}deg)`,
  };

  if (kind === 'circle') {
    return (
      <span
        className="absolute rounded-full"
        style={{
          ...style,
          width: size,
          height: size,
          backgroundColor: color,
        }}
      />
    );
  }
  if (kind === 'rect') {
    return (
      <span
        className="absolute rounded-[2px]"
        style={{
          ...style,
          width: size,
          height: size * 0.45,
          backgroundColor: color,
        }}
      />
    );
  }
  if (kind === 'triangle') {
    return (
      <span
        className="absolute"
        style={{
          ...style,
          width: 0,
          height: 0,
          borderLeft: `${size / 2}px solid transparent`,
          borderRight: `${size / 2}px solid transparent`,
          borderBottom: `${size}px solid ${color}`,
        }}
      />
    );
  }
  return (
    <svg
      className="absolute"
      style={{ ...style, width: size, height: size * 0.45 }}
      viewBox="0 0 24 10"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M1 5c2-3 4-3 6 0s4 3 6 0 4-3 6 0 4 3 6 0"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
